import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { APISERVICE, getToken } from 'services/api.service'

const APIURL = process.env.REACT_APP_API_URL

export function Ayuda() {
    const [params, setParams] = useState({ urlManual: null, urlVideo: '' })
    const { roles } = useSelector((state) => state.auth)
    const role = roles.length > 0 ? roles[0] : ''

    useEffect(() => {
        const loadPathManual = async () => {
            const manual = `manual_${role}`
            const video = `video_${role}`
            const url = `configuracion/get?claves[]=${manual}&claves[]=${video}`
            const data = await APISERVICE.get(url, '')
            const _urlVideo = data[video] ? data[video].valor : ''
            let _urlManual = null
            if (data[manual]) {
                _urlManual = await getPdfObjectUrl(data[manual].valor)
            }
            setParams({
                urlManual: _urlManual,
                urlVideo: _urlVideo,
            })
        }
        loadPathManual()
    }, [role])

    async function getPdfObjectUrl(filename) {
        try {
            // Paso 1: Descargar el PDF desde la URL
            const response = await fetch(`${APIURL}configuracion/get-file?filename=${filename}`, {
                headers: {
                    Authorization: getToken(),
                },
            })
            if (!response.ok) {
                throw new Error(`Error fetching PDF: ${response.statusText}`)
            }

            // Paso 2: Convertir la respuesta en un Blob
            const pdfBlob = await response.blob()

            // Paso 3: Crear un ObjectURL a partir del Blob
            const objectUrl = URL.createObjectURL(pdfBlob)

            return objectUrl
        } catch (error) {
            console.error('Error:', error)
            return null
        }
    }

    return (
        <div className='container p-5'>
            {params.urlVideo && (
                <>
                    <div className='text-center fs-3 mb-3'>Funciones del sistema</div>
                    <div className='w-100 mb-3' style={{ aspectRatio: '16 / 9' }}>
                        <iframe
                            src={params.urlVideo}
                            title='YouTube video player'
                            frameborder='0'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                            referrerpolicy='strict-origin-when-cross-origin'
                            allowfullscreen
                            style={{ width: '100%', height: '100%' }}
                        ></iframe>
                    </div>
                </>
            )}
            <div className='text-center fs-3 mb-3'>Manual de Usuario</div>
            <div className='w-100' style={{ height: '90vh', backgroundColor: '#e9ecef' }}>
                {params.urlManual ? (
                    <embed src={params.urlManual} type='application/pdf' className='w-100 h-100'></embed>
                ) : (
                    <div
                        className='h-100 d-flex align-items-center justify-content-center fs-5'
                        style={{ border: '2px solid #dee2e6' }}
                    >
                        Manual no disponible
                    </div>
                )}
            </div>
        </div>
    )
}
